export default {
  isAdmin: (state) => state.isAdmin,
  isLogged: (state) => state.isLogged,
  isRouteAuthorized: (state) => state.isRouteAuthorized,
  currentUser: (state) => state.currentUser,
};
